import { ActivityEntityName } from '../../../../entities';
import { MergeDataset, MergeSource } from '../../decorators';
import { BulkInvoiceJobMergeData, BulkInvoiceJobMergeSchema, ContactMergeData, ContactMergeSchema } from '../data';

@MergeDataset({
    entity: ActivityEntityName.BulkInvoiceJob,
})
export class BulkInvoiceJobMergeDataset {
    @MergeSource({
        schema: BulkInvoiceJobMergeSchema,
    })
    job: BulkInvoiceJobMergeData;

    @MergeSource({
        schema: ContactMergeSchema,
        ignoreCustomFields: true,
    })
    jobPrimaryContact: ContactMergeData;
}